import React, { useEffect } from 'react';

/**
 * OAuth Callback Handler
 *
 * This component handles the OAuth callback from Microsoft Entra ID
 * Extracts tokens from URL and stores them in sessionStorage
 */
function OAuthCallback() {
  useEffect(() => {
    const handleCallback = async () => {
      try {
        // Parse URL parameters
        const params = new URLSearchParams(window.location.search);
        const code = params.get('code');
        const state = params.get('state');
        const error = params.get('error');

        if (error) {
          // Force account selection on next login to break potential login loop
          // (e.g. AADSTS50178: wrong account picked from multi-account browser session)
          setTimeout(() => {
            window.location.href = `/manheimsupport/login?prompt=select_account&login_error=${encodeURIComponent(error)}`;
          }, 3000);
          return;
        }

        if (!code) {
          // Redirect to login
          setTimeout(() => {
            window.location.href = '/manheimsupport/login';
          }, 3000);
          return;
        }

        // Exchange authorization code for tokens via backend
        const apiUrl = process.env.REACT_APP_MANHEIM_SUPPORT_API_URL || '/api';
        const redirectUri = `${window.location.origin}/manheimsupport/callback`;
        const response = await fetch(`${apiUrl}/auth/token`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ code, state, redirectUri })
        });

        if (!response.ok) {
          throw new Error('Token exchange failed');
        }

        const tokenData = await response.json();

        if (!tokenData.id_token) {
          throw new Error('Invalid token response from server');
        }

        // Store id_token in sessionStorage for API calls
        sessionStorage.setItem('id_token', tokenData.id_token);

        // Redirect to main app
        setTimeout(() => {
          window.location.href = '/manheimsupport/index';
        }, 500);
      } catch (error) {
        setTimeout(() => {
          window.location.href = '/manheimsupport/login';
        }, 3000);
      }
    };

    handleCallback();
  }, []);

  return (
    <div className="auth-container">
      <div className="auth-spinner" />
    </div>
  );
}

export default OAuthCallback;
